
<div class="upload-container">
  <div class="upload-section" *ngIf="!uploadStarted && !(uploadComplete$ | async) && !(uploadError$ | async)">
    <div class="instructions">
      <h3>Before You Start</h3>
      <mat-list class="instruction-list">
        <mat-list-item>
          <span matListItemTitle>1. Download the template file below</span>
        </mat-list-item>
        <mat-list-item>
          <span matListItemTitle>2. Fill in your provider information</span>
        </mat-list-item>
        <mat-list-item>
          <span matListItemTitle>3. Save and upload the completed file</span>
        </mat-list-item>
      </mat-list>
      
      <button mat-raised-button color="primary" (click)="downloadTemplate()" class="download-btn">
        <mat-icon>download</mat-icon>
        Download Template
      </button>
    </div>

    <div class="upload-area" 
         [class.dragover]="isDragOver"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)"
         (click)="fileInput.click()">
      
      <input #fileInput
             type="file" 
             accept=".xlsx,.csv"
             (change)="onFileSelected($event)"
             style="display: none;">
      
      <div class="upload-content">
        <mat-icon class="upload-icon">cloud_upload</mat-icon>
        <p class="upload-text">Drag and drop your file here or click to select</p>
        <small>Supports .xlsx and .csv files (max 10MB)</small>
      </div>
    </div>

    <div class="selected-file" *ngIf="selectedFile">
      <div class="file-display">
        <mat-icon>description</mat-icon>
        <div class="file-details">
          <span class="file-name">{{ selectedFile.name }}</span>
          <span class="file-size">({{ formatFileSize(selectedFile.size) }})</span>
        </div>
        <button mat-icon-button (click)="removeFile()" color="warn">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      
      <div class="upload-action">
        <button mat-raised-button 
                color="accent" 
                (click)="uploadFile()"
                [disabled]="uploadLoading$ | async"
                class="upload-btn">
          <mat-icon>upload</mat-icon>
          Upload Providers
        </button>
      </div>
    </div>
  </div>

  <div class="upload-section" *ngIf="uploadStarted && !(uploadComplete$ | async)">
    <div class="progress-content">
      <div class="progress-header">
        <mat-spinner diameter="24"></mat-spinner>
        <span>Uploading and processing providers...</span>
      </div>
      <mat-progress-bar 
        mode="determinate" 
        [value]="uploadProgress$ | async">
      </mat-progress-bar>
    </div>
  </div>

  <div class="upload-section" *ngIf="uploadResults$ | async as results">
    <div class="results-header">
      <h3>Upload Complete</h3>
    </div>
    
    <div class="results-stats">
      <div class="stat-card">
        <span class="stat-number">{{ results.totalProcessed }}</span>
        <span class="stat-label">Total Processed</span>
      </div>
      <div class="stat-card success">
        <span class="stat-number">{{ results.created }}</span>
        <span class="stat-label">Created</span>
      </div>
      <div class="stat-card info">
        <span class="stat-number">{{ results.updated }}</span>
        <span class="stat-label">Updated</span>
      </div>
      <div class="stat-card error" *ngIf="results.errors > 0">
        <span class="stat-number">{{ results.errors }}</span>
        <span class="stat-label">Errors</span>
      </div>
    </div>

    <div class="error-section" *ngIf="results?.errorDetails && results.errorDetails.length > 0">
      <button mat-stroked-button (click)="toggleErrors()" class="error-toggle">
        <mat-icon>{{ showAllErrors ? 'expand_less' : 'expand_more' }}</mat-icon>
        {{ showAllErrors ? 'Hide Errors' : 'Show Error Details' }}
      </button>
      
      <div class="error-list-container" *ngIf="showAllErrors">
        <div class="error-list">
          <div class="error-item" *ngFor="let error of results.errorDetails">
            <strong>Row {{ error.row }}:</strong> {{ error.message }}
          </div>
        </div>
      </div>
    </div>

    <div class="results-actions">
      <button mat-raised-button color="primary" (click)="uploadAnother()">
        Upload Another File
      </button>
      <button mat-button (click)="closeModal()">
        Close
      </button>
    </div>
  </div>

  <div class="upload-section" *ngIf="uploadError$ | async as error">
    <div class="error-content">
      <mat-icon color="warn" class="error-icon">error</mat-icon>
      <div class="error-details">
        <h3>Upload Failed</h3>
        <p>{{ error }}</p>
      </div>
    </div>
    <div class="error-actions">
      <button mat-raised-button color="primary" (click)="clearError()">
        Try Again
      </button>
      <button mat-button (click)="closeModal()">
        Close
      </button>
    </div>
  </div>

</div>